const reducer = state => ({
  ...state,
  inProgress: false,
});

export default reducer;
